module.exports = __webpack_public_path__ + "img/icon_person_avator.21b669d2.png";